module App.Interfaces
{
    export interface IAlternativeBrands
    {
        brandUrl: string
        brandName: string
    }
}